// What the storefront prints when a Google field is left blank, in the
// backend's own words (app/services/customer/landing_page.py), so the
// preview never promises a sentence the page would not say.
const SITE = { en: "Nysmah", ar: "نسمة" };

export const metaTitleFallback = (lang, name) => `${name} | ${SITE[lang] || SITE.en}`;

export const metaDescriptionFallback = (lang, name) =>
  lang === "ar"
    ? `تسوّق ${name} من ${SITE.ar}: ماركات أصلية 100٪ مع توصيل سريع لجميع مناطق السعودية.`
    : `Shop ${name} at ${SITE.en}: 100% original brands with fast delivery across Saudi Arabia.`;

/**
 * The page's address on the storefront: the fixed path once the page
 * exists, else the one its name would get. `guess` is the path without
 * the language, e.g. "care", "care/facecare", "brands/dior".
 */
export const pageAddress = (lang, landingPage, guess) => `/${lang}/${landingPage?.path || guess}`;

/** "/en/care/facecare" as Google prints it: "› en › care › facecare". */
export const crumbPath = (address) =>
  address
    .split("/")
    .filter(Boolean)
    .map((segment) => `› ${segment}`)
    .join(" ");
